module.exports = __webpack_public_path__ + "img/img_01_2.e0dfb31d.png";